// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-container-R879O {
  display: flex;
  align-items: center;
  cursor: default;
  margin: 2px auto;
  padding: 8px 16px;
  cursor: pointer;
}

.option-container-R879O:hover {
  background-color: var(--background-color);
}

.option-containerDisabled-w9YRi:hover {
  background-color: inherit;
  cursor: default;
}

.option-icon-wxYIv {
  --size: 24px;
  margin-right: 16px;
}

.option-iconDisabled-BUgBK {
  color: rgba(0, 0, 0, 0.6);
}

.option-text-_se09 {
  font-size: 15px;
}

.option-textDisabled-_Znrm {
  color: rgba(0, 0, 0, 0.7);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/option/option.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  cursor: default;\n  margin: 2px auto;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.container:hover {\n  background-color: var(--background-color);\n}\n\n.containerDisabled:hover {\n  background-color: inherit;\n  cursor: default;\n}\n\n.icon {\n  --size: 24px;\n  margin-right: 16px;\n}\n\n.iconDisabled {\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.text {\n  font-size: 15px;\n}\n\n.textDisabled {\n  color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `option-container-R879O`,
	"containerDisabled": `option-containerDisabled-w9YRi`,
	"icon": `option-icon-wxYIv`,
	"iconDisabled": `option-iconDisabled-BUgBK`,
	"text": `option-text-_se09`,
	"textDisabled": `option-textDisabled-_Znrm`
};
export default ___CSS_LOADER_EXPORT___;
